const ROUTE_VIEW_HOME = [
  {
    path: '/',
    redirect: '/index'
  },
  { path: "/index", name: "首页", h5Uri: "/home/index" },
  { path: "/login", name: "登录", h5Uri: "/login/index" },
  { path: "/leave", name: "请假", h5Uri: "/leave/index" },
  { path: "/leave_record", name: "请假记录", h5Uri: "/leave/leave_record" },
  { path: "/leave_approval", name: "请假审批", h5Uri: "/leave/leave_approval" },
  { path: "/studentstay", name: "学生留宿", h5Uri: "/studentstay/index" },
  {
    path: "/dayapplication",
    name: "走读申请记录",
    h5Uri: "/dayapplication/index"
  },
  {
    path: "/dayapplication/dayapplication_approval",
    name: "走读申请审批",
    h5Uri: "/dayapplication/dayapplication_approval"
  },
  { path: "/checkingin", name: "考勤设置", h5Uri: "/checkingin/index" },
  {
    path: "/checkingin/accessstrategy/",
    name: "新增出入策略",
    h5Uri: "/checkingin/accessstrategy"
  },
  {
    path: "/checkingin/organization",
    name: "组织人员",
    h5Uri: "/checkingin/organization"
  },
  {
    path: "/checkingin/attendance_points/:id",
    name: "新增考勤点",
    h5Uri: "/checkingin/attendance_points"
  },
  { path: "/entrypass", name: "出入许可申请", h5Uri: "/entrypass/index" },
  {
    path: "/studentstay/applicationforstay",
    name: "学生留宿",
    h5Uri: "/studentstay/applicationforstay"
  },
  {
    path: "/studentstay/stay_approval",
    name: "留宿审批",
    h5Uri: "/studentstay/stay_approval"
  },
  {
    path: "/attendance/attendance_record",
    name: "考勤记录",
    h5Uri: "/attendance/attendance_record"
  },
  {
    path: "/clocking/clocking_record",
    name: "打卡记录",
    h5Uri: "/clocking/clocking_record"
  },
  {
    path: "/overnight/overnight_record",
    name: "宿分记录",
    h5Uri: "/overnight/overnight_record"
  },
  {
    path: "/overnight/overnight_item",
    name: "宿分详情",
    h5Uri: "/overnight/overnight_item"
  },
  {
    path: "/overnight/overnight_detail",
    name: "宿舍宿分详情",
    h5Uri: "/overnight/overnight_detail"
  },
  {
    path: "/studentinfo/student_info",
    name: "学生信息",
    h5Uri: "/studentinfo/student_info"
  },
  {
    path: "/studentinfo/student_detail",
    name: "学生详情",
    h5Uri: "/studentinfo/student_detail"
  },
  {
    path: "/leave/licence_record",
    name: "出入许可列表",
    h5Uri: "/leave/licence_record"
  },
  {
    path: "/studentinfo/student_group",
    name: "选择编辑的学生分组",
    h5Uri: "/studentinfo/student_group"
  },
  {
    path: "/studentinfo/student_group_edit",
    name: "编辑分组的学生",
    h5Uri: "/studentinfo/student_group_edit"
  },
  {
    path: "/dayapplication/dayapplication_apply",
    name: "走读申请",
    h5Uri: "/dayapplication/dayapplication_apply"
  },
  {
    path: "/dayapplication/dayapplication_apply",
    name: "走读申请",
    h5Uri: "/dayapplication/dayapplication_apply"
  },
  {
    path: "/campusaccess/access_management",
    name: "校园出入管理",
    h5Uri: "/campusaccess/access_management"
  },
];
export default ROUTE_VIEW_HOME;



// WEBPACK FOOTER //
// ./src/router/mapping/home.js